import React from "react";
import { compose } from 'redux';
import { Prompt, withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import PropTypes from "prop-types";
import moment from 'moment';
import Header from "../components/Header";
import Tabs from '../components/Tabs';
import Tab from '../components/Tab';
import PartExceptionsSearchBox from "../components/PartExceptionsSearchBox";
import EditPartExceptionPage from './EditPartExceptionPage';
import PartDemandPage from './PartDemandPage';
//import { /*Input, */NumericTextBox } from '@progress/kendo-react-inputs';
import { queryStringBuilder, getExportFileName, isEmpty/*, escapeSlashes*/, convertDatestampToObject, getLocaleDateString, convertDateToInteger } from "../helpers";
import { /*BooleanCell, */DateCell, /*DeleteCell, */BlankCell, IconButtonCell } from "../components/utils/GridHelpers";
import GridContainer/*, { GridContainerToolbar, GridContainerToolbarOption }*/ from '../components/GridContainer';
import {
    GridColumn as Column/*,
    GridToolbar,
    GridDetailRow,*/
} from "@progress/kendo-react-grid";
//import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from '@progress/kendo-react-buttons';
import "@progress/kendo-theme-material/dist/all.css";
import isPage from "../hoc/isPage";
import checkedDisabledIcon2 from '../img/icon-checked-disabled2.svg';
import { AppContext } from '../context/AppContext';
import localize from "../hoc/localize";

const NavigateAwayDialog = (props) => {

    //let top = window.visualViewport.pageTop + (window.innerHeight - 200) / 2;
    let top = window.pageYOffset + (window.innerHeight - 200) / 2;
    return (
        <Dialog className="confirmation"
            width={400}
            style={{ height: 'auto', top: top, margin: '0 auto' }}
            onClose={props.handleCloseDialog}>

            {this.props.returnLocalizedString("m0251")}
            <DialogActionsBar>
                <Button className="cancel" onClick={props.handleCloseDialog}>{this.props.returnLocalizedString("m0101")}</Button>
                <Button className="yes" primary={true} onClick={(e) => {
                    props.handleSave();
                    props.handleConfirmNavigate();
                    props.handleCloseDialog();
                }}>{this.props.returnLocalizedString("m0252")}</Button>
                <Button className="no" onClick={(e) => {
                    props.handleConfirmNavigate();
                    props.handleCloseDialog();
                }}>{this.props.returnLocalizedString("m0253")}</Button>
            </DialogActionsBar>
        </Dialog>
    )
}
NavigateAwayDialog.propTypes = {
    handleConfirmNavigate: PropTypes.func,
    handleCloseDialog: PropTypes.func,
    handleSave: PropTypes.func
}

//class StockingMAXCell extends React.Component {
//    handleStockingMAXChange = (e) => {
//        this.props.onChange({
//            dataItem: this.props.dataItem,
//            field: this.props.field,
//            syntheticEvent: e.syntheticEvent,
//            value: e.target.value
//        });

//        if (e.target.value === 0)
//            this.props.onChange({
//                dataItem: this.props.dataItem,
//                field: 'neverOrder',
//                value: true
//            })
//    }

//    zeroOutStockingMAX = (e) => {
//        this.props.onChange({
//            dataItem: this.props.dataItem,
//            field: 'stockingMAX',
//            value: null
//        })
//    }

//    render() {
//        return (
//            <td className="numeric">
//                <NumericTextBox
//                    width={90}
//                    min={0}
//                    disabled={this.props.dataItem['neverOrder']}
//                    name="stockingMAX"
//                    onChange={this.handleStockingMAXChange}
//                    value={this.props.dataItem['stockingMAX']} />
//                <span onClick={this.zeroOutStockingMAX} style={{
//                    'cursor': 'pointer'
//                }}>X</span>
//            </td>
//        )
//    }
//}

class DescWithPackageInfoCell extends React.Component {
    render() {
        return (
            <td>
                {this.props.dataItem['partDescription']}
                {this.props.dataItem['package'] && (<div className="quantities"><span>{this.props.dataItem['packageCount']}</span> {this.props.returnLocalizedString("m0254")}</div>)}
            </td>
        );
    }
}

class NeverOrderCell extends React.Component {
    render() {
        return (
            <td>
                <span style={{ width: '20%', 'alignItems': 'center' }}>{this.props.dataItem['neverOrder'] ? <img style={{ width: 18, height: 18 }} src={checkedDisabledIcon2} alt="V" /> : <span />}</span>
                <span style={{ width: '80%', 'alignItems': 'center', 'paddingLeft': '10px' }}>{this.props.dataItem['adjReason'] ? this.props.dataItem['adjReason'].adjustmentReason : ''}</span>
            </td>
        );
    }
}

class ModifiedCell extends React.Component {
    render() {
        const localeDateString = getLocaleDateString().toUpperCase();
        const value = this.props.dataItem[this.props.field];
        return (
            <td>
                <span>
                    {
                        (value === null) ? '' : moment(convertDatestampToObject(value)).format(localeDateString)
                    }
                </span>
                <br />
                <span className="modifiedby">
                    {
                        (this.props.dataItem['modifiedBy'] === null) ? '' : this.props.label + this.props.dataItem['modifiedBy']
                    }
                </span>
            </td>
        );
    }
}

class SeasonCell extends React.Component {
    render() {
        if (this.props.dataItem['season']) {
            const value = this.props.dataItem['season'].seasonName;
            return (
                <td>
                    <span>
                        {
                            (value === null) ? '' : value
                        }
                    </span>
                    <br />
                    <span className="seasonMin">
                        {
                            (this.props.dataItem['seasonMin'] === null) ? '' : this.props.label + this.props.dataItem['seasonMin']
                        }
                    </span>
                </td>
            );
        }
        else {
            return (
                <td>
                    <span />
                    <span className="seasonMin">
                        {
                            (this.props.dataItem['seasonMin'] === null) ? '' : this.props.label + this.props.dataItem['seasonMin']
                        }
                    </span>
                </td>
            );
        }
    }
}

export class StockingMinMaxCell extends React.Component {
    render() {
        const value = this.props.dataItem[this.props.field];
        return (
            <td className="numeric">
                {
                    (value === null) ? '-' : `${value}`
                }
            </td>
        );
    }
}


function columns (props) { 
    return [
    { field: "partNumber", key: "partNumber", title: props.returnLocalizedString("m0257"), minWidnt: 20, editable: false },
    { field: "partDescription", key: "partDescription", title: props.returnLocalizedString("m0258"), minWidnt: 20, editable: false, cell: localize(DescWithPackageInfoCell) },
    { field: "vendorCode", key: "vendorCode", title: props.returnLocalizedString("m0259"), minWidnt: 20, editable: false },
    { field: "qtyAvailable", key: "qtyAvailable", title: props.returnLocalizedString("m0260"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
    { field: "qtySold", key: "qtySold", title: props.returnLocalizedString("m0261"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
    { field: "stockingMIN", key: "stockingMIN", title: props.returnLocalizedString("m0262"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: StockingMinMaxCell },
    { field: "minExpiryDate", key: "minExpiryDate", title: props.returnLocalizedString("m0263"), minWidnt: 20, editable: false, cell: DateCell },
    { field: "stockingMAX", key: "stockingMAX", title: props.returnLocalizedString("m0264"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: StockingMinMaxCell },
    { field: "maxExpiryDate", key: "maxExpiryDate", title: props.returnLocalizedString("m0265"), minWidnt: 20, editable: false, cell: DateCell },
    { field: "season.seasonName", key: "season.seasonName", title: props.returnLocalizedString("m0266"), minWidnt: 20, editable: false, cell: localize(SeasonCell) },
    { field: "neverOrder", key: "neverOrder", title: props.returnLocalizedString("m0267"), minWidnt: 20, editable: false, headerClassName: "boolean", className: "boolean", cell: NeverOrderCell },
    { field: "modifiedOn", key: "modifiedOn", title: props.returnLocalizedString("m0268"), minWidnt: 20, editable: false, cell: localize(ModifiedCell) },
    { key: "button1", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: IconButtonCell },
    { key: "button2", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: IconButtonCell },
    { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
]};

const ADJUST_PADDING = 0;
const COLUMN_MIN = 4;

class PartExceptionsPage extends React.Component {
    _export;
    fieldRequired = false;

    minGridWidth = 0;

    constructor(props) {
        super(props);

        this.state = {
            partExceptions: null,
            searchParams: {
                selectedPartNumber: ""
            },
            sort: [
                {
                    field: "partNumber",
                    dir: "asc"
                }
            ],
            orgID: null, // the selected orgID, or the user orgID (for dealer user)
            unsaved: false, // indicates that changes have been made to the part exceptions that haven't been saved yet
            nextLocation: '', // URL that the user attempted to navigate to before saving his changes
            performRedirect: false, // when set to true, indicates that user wants to navigate away without saving changes

            showDialog: false,
            showDetailsDialog: false,
            selectedException: null,

            setMinWidth: false,
            gridCurrent: 0
        };
    }

    //state = {
    //    partExceptions: null,
    //    searchParams: {
    //        selectedPartNumber: ""
    //    },
    //    sort: [
    //        {
    //            field: "partNumber",
    //            dir: "asc"
    //        }
    //    ],
    //    skip: 0,
    //    take: 10
    //};

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleSearch = e => {
        // get the items selected from the search filters control
        //if (e.preventDefault !== undefined)
        e.preventDefault();

        let builder = new queryStringBuilder();

        const searchParams = this.state.searchParams;

        // set selectedException to 'All Exceptions' the first time the page is loaded
        if (isEmpty(searchParams.selectedException))
            searchParams.selectedException = { exceptionID: 0, exception: this.props.returnLocalizedString("m0269") };

        // check if all required parts have been entered
        if (isEmpty(searchParams.selectedPartNumber) &&
            (isEmpty(searchParams.selectedException) || searchParams.selectedException.exceptionID < 0)) {
            this.props.alert(
                "error",
                this.props.returnLocalizedString("m0023"),
                this.props.returnLocalizedString("m0270")
            );
            this.fieldRequired = true;
            this.forceUpdate();
            return;
        }

        // run the api search for the parts using these search parameters
        if (searchParams.selectedPartNumber) {
            builder.append("partNumber", searchParams.selectedPartNumber);
        }
        let orgID;
        if (searchParams.selectedDealership) {
            orgID = searchParams.selectedDealership.orgID;
            if (orgID > 0)
                builder.append("orgID", orgID);
        }
        if (searchParams.selectedVendor && !isEmpty(searchParams.selectedVendor.orgVendorID)) {
            builder.append("orgVendorID", searchParams.selectedVendor.orgVendorID);
        }
        if (searchParams.selectedVendor && !isEmpty(searchParams.selectedVendor.vendorID)) {
            builder.append("vendorID", searchParams.selectedVendor.vendorID);
        }
        if (searchParams.selectedException) {
            builder.append("exception", searchParams.selectedException.exceptionID);
        }
        builder.append("uiLanguage", this.props.uiLanguage)

        this.props.getData(`/api/portal/adjustmentReason/GetList?uiLanguage=${this.props.uiLanguage}`).then((adjustmentReasons) => {
            this.setState({
                adjustmentReasons: [{ adjustmentReasonID: null, adjustmentReason: "" }].concat(adjustmentReasons.data),
            })
        });

        if (!orgID || orgID <= 0)
            orgID = this.context.state.orgID;
        this.props.getData(`/api/portal/season/${orgID}`).then((seasons) => {
            this.setState({
                seasons: [{ seasonID: null, seasonName: "" }].concat(seasons.data),
            })
        });

        // filter the data
        this.props
            .getData(
                `/api/portal/part/GetPartExceptions${builder.queryString}`
            )
            .then(response => {
                // grid may not exist yet, but it has the same width as the search-controls, so use it to calculate column widths
                //this.grid = document.querySelector('.k-grid');
                this.grid = document.querySelector('.search-controls');
                window.addEventListener('resize', this.handleResize);
                //console.log("grid.offsetWidth: ", this.grid.offsetWidth);

                this.minGridWidth = 755;
                columns(this.props).map(item => this.minGridWidth += item.minWidnt);

                //console.log("grid.offsetWidth: ", this.grid.offsetWidth);
                //console.log("minGridWidth: ", this.minGridWidth);
                this.setState({
                    partExceptions: response.data.map((lineItem, index) => Object.assign({
                        inEdit: true,   // the Boolean field which indicates the edit state of the item
                        updated: false, // the Boolean field which indicates whether the item have be updated
                        index,
                    }, lineItem)),
                    orgID: (orgID > 0 ? orgID : this.context.state.orgID),

                    gridCurrent: this.grid.offsetWidth,
                    setMinWidth: this.grid.offsetWidth < this.minGridWidth
                });
                this.handleResize();
            })
            .catch(error => {

                this.props.alert(
                    "error",
                    this.props.returnLocalizedString("m0023"),
                    this.props.returnLocalizedString("m0271")
                );
            });
    };

    handleResize = () => {

        if (this.grid) {
            if (this.grid.offsetWidth < this.minGridWidth && !this.state.setMinWidth) {
                this.setState({
                    setMinWidth: true
                });
            } else if (this.grid.offsetWidth > this.minGridWidth) {
                this.setState({
                    gridCurrent: this.grid.offsetWidth,
                    setMinWidth: false
                });
            }
        }
    }

    setWidth = (minWidth, percentage) => {
        //let columnsLength;
        //if (this.context.state.allowEditSuggestedOrders)
        //    columnsLength = columnsAllowEdit.length;
        //else
        //    columnsLength = columnsNotAllowEdit.length;
        //let width = this.state.setMinWidth ? minWidth :
        //    minWidth + (this.state.gridCurrent - this.minGridWidth) / columnsLength;
        let width = this.state.setMinWidth ? minWidth :
            Math.round(this.state.gridCurrent / 100 * percentage);
        width = width < COLUMN_MIN ? width : width - ADJUST_PADDING;
        return width;
    }

    handleSearchParamsChange = e => {
        this.setState({
            searchParams: {
                ...this.state.searchParams,
                [e.target.name]: e.target.value
            }
        });
    };

    export = () => {
        this._export.save(this.state.partExceptions);
    };

    handleItemChange = (e) => {
        //console.log('handleItemChange')
        e.dataItem[e.field] = e.value
        e.dataItem['updated'] = true

        const index = e.dataItem['index']

        this.setState({
            partExceptions: Object.assign([], this.state.partExceptions, { [index]: e.dataItem }),
            unsaved: true
        })
    }

    handleAdjustmentReasonChange = (dataItem, value) => {
        //debugger;
        dataItem['adjReason'] = value;
        dataItem['updated'] = true

        this.setState({
            partExceptions: [...this.state.partExceptions],
            unsaved: true
        })
    }

    handleNeverOrderChange = (dataItem) => {
        // value = true, means that the checkbox is checked
        //debugger;
        //console.log('neverorder', value)

        const neverOrder = !dataItem['neverOrder'];

        // flip the order around
        dataItem['neverOrder'] = neverOrder;
        if (neverOrder) {
            dataItem['stockingMAX'] = 0;
        }
        dataItem['updated'] = true

        this.setState({
            partExceptions: [...this.state.partExceptions],
            unsaved: true
        })
    }

    // validate the user's inputs
    validateInputValues = () => {

        let error = "";

        !isEmpty(this.state.partExceptions) && this.state.partExceptions.forEach(partException => {
            if ((partException.neverOrder !== null && partException.neverOrder)
                && (partException.adjReason === null || partException.adjReason.adjustmentReasonID === null)) {
                error = this.props.returnLocalizedString("m0272", 
                "",  partException.partNumber);
            }
        });

        if (!isEmpty(error)) {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), error);
            return false;
        }
        return true;
    }

    handleSaveChanges = () => {
        //console.log(`saving the following part exceptions...`, this.state.partExceptions)

        let updatedPE = this.state.partExceptions.filter(pe => pe.updated);
        if (updatedPE.length <= 0) {
            this.props.alert("warning", this.props.returnLocalizedString("m0273"), this.props.returnLocalizedString("m0274"))
            return;
        }

        // validate the inputs
        if (!this.validateInputValues()) {
            return;
        }

        const orgType = this.context.state.orgType;
        const searchParams = this.state.searchParams;
        let orgID;
        if (searchParams.selectedDealership) {
            orgID = searchParams.selectedDealership.orgID;
        }
        const extractedData = updatedPE.map((partException, index) => {

            let adjustmentReasonID = null
            // null out adjustmentReasonID if stockingMAX has been blanked out and neverOrder is false
            if (((partException.stockingMAX !== null && partException.stockingMAX.toString().length > 0) && (partException.stockingMAX > 0))
                || (partException.neverOrder !== null && partException.neverOrder)) {
                if (partException.adjReason)
                    adjustmentReasonID = partException.adjReason.adjustmentReasonID
            }

            return ({
                partNumber: partException.partNumber,
                orgVendorID: partException.orgVendorID,
                neverOrder: partException.neverOrder,
                stockingMAX: partException.stockingMAX,

                adjustmentReasonID,

                orgID: (orgType === "dealergroup" ? orgID : null)
            })
        })

        this.props.postData(`/api/portal/part/UpdatePartExceptions`, extractedData).then(response => {
            this.props.alert("success", this.props.returnLocalizedString("m0036"), this.props.returnLocalizedString("m0275", "", extractedData.length))

            const today = new Date();
            const intToday = convertDateToInteger(today);

            // lower this flag, since a save has just been performed
            this.setState({
                unsaved: false,
                partExceptions: this.state.partExceptions.map(partException => {
                    // if stockingMAX is blank and neverOrder is false, then let's remove the adjustment reason
                    if ((partException.stockingMAX === null || partException.stockingMAX.toString().length === 0) && (partException.neverOrder === null || !partException.neverOrder)) {
                        partException.adjReason = {
                            adjustmentReason: null,
                            adjustmentReasonID: null
                        };
                    }
                    partException.modifiedBy = this.context.state.userName;
                    partException.modifiedOn = intToday;
                    partException.updated = false;
                    return partException;
                })
            })
        }).catch(error => {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), error.message)
        })
    }

    // show dialog to confirm whether user wants to navigate away despite having unsaved changes
    showNavigateAwayDialog = (location) => {
        //debugger;
        this.setState({
            showNavigateAwayDialog: true,
            nextLocation: location
        })
    }

    // navigate away
    handleConfirmNavigate = () => {
        this.setState({
            performRedirect: true
        })
    }

    // close the "are you sure you want to leave without saving changes" dialog
    handleCloseDialog = () => {
        this.setState({
            showNavigateAwayDialog: false
        })
    }

    // save the change before navigate away
    handleSave = () => {
        //this.setState({
        //    showNavigateAwayDialog: false
        //})
    }

    handleCloseModal = (elmnt, payload) => {

        if (payload) {
            if (payload[0]) {
                const partExceptions = this.state.partExceptions;
                let partException = partExceptions.find(partException => partException.orgVendorID === payload[0].orgVendorID && partException.partNumber === payload[0].partNumber);

                const today = new Date();
                const intToday = convertDateToInteger(today);

                partException.neverOrder = payload[0].neverOrder;
                partException.stockingMIN = payload[0].neverOrder ? null : payload[0].stockingMIN;
                partException.stockingMAX = payload[0].neverOrder ? null : payload[0].stockingMAX;
                partException.minExpiryDate = payload[0].neverOrder ? null : payload[0].minExpiryDate;
                partException.maxExpiryDate = payload[0].neverOrder ? null : payload[0].maxExpiryDate;
                partException.season = payload[0].neverOrder ? null : this.state.seasons.find(s => s.seasonID === payload[0].seasonID);
                partException.seasonMin = payload[0].neverOrder ? null : (payload[0].seasonMin === 0 ? null : payload[0].seasonMin);
                partException.adjReason = this.state.adjustmentReasons.find(r => r.adjustmentReasonID === payload[0].adjustmentReasonID);
                partException.modifiedOn = intToday;
                partException.modifiedBy = this.context.state.userName;

                //console.log('user name is ' + this.context.state.userName);

                this.setState({
                    showDialog: false,
                    selectedException: null,
                    partExceptions: partExceptions
                });
            }
        }
        else
            this.setState({
                showDialog: false,
                selectedException: null
            });
    }

    handleEditClick = (e, props) => {

        // bring up the dialog
        this.setState({
            showDialog: true,
            selectedException: props.dataItem
        })
    }

    handleDetailsClick = (e, props) => {

        // bring up the dialog
        this.setState({
            showDetailsDialog: true,
            selectedException: props.dataItem
        })
    }

    handleCloseDetailsModal = (e, props) => {

        this.setState({
            showDetailsDialog: false,
            selectedException: null
        });
    }

    render() {
        //let toolBarContent = "";
        //let saveButton = (
        //    <GridContainerToolbar>
        //        <GridContainerToolbarOption type="save" tooltip="m0252" handleClick={this.handleSaveChanges} />
        //    </GridContainerToolbar>
        //);

        if (this.state.performRedirect && (!isEmpty(this.state.nextLocation))) {

            return <Redirect to={this.state.nextLocation} />
        }

        //let top = window.visualViewport.pageTop + (window.innerHeight - 200) / 2;
        let top = window.pageYOffset + (window.innerHeight - 200) / 2;

        //const columns = [];
        //<Column
        //    field="status"
        //    title="Status"
        //    width="100px"
        //    editable={false}
        ///>
        //{ saveButton }

        // 448px is the perfect width with the current css styles
        let perfectPartExceptionDialogWidth = 448;
        let partExceptionDialogWidth = `${perfectPartExceptionDialogWidth}px`;
        if (this.state.showDialog) {
            this.dialogWrapper = document.querySelector('.k-dialog-wrapper');
            if (this.dialogWrapper)
                if (this.dialogWrapper.offsetWidth < perfectPartExceptionDialogWidth)
                    partExceptionDialogWidth = `${this.dialogWrapper.offsetWidth}px`;
        }

        // 646px is the perfect width with the current css styles
        let perfectPartDemandDialogWidth = 646;
        let partDemandDialogWidth = `${perfectPartDemandDialogWidth}px`;
        if (this.state.showDetailsDialog) {
            this.dialogWrapper = document.querySelector('.k-dialog-wrapper');
            if (this.dialogWrapper)
                if (this.dialogWrapper.offsetWidth < perfectPartDemandDialogWidth)
                    partDemandDialogWidth = `${this.dialogWrapper.offsetWidth}px`;
        }

        const tabs = (<Tabs>
            <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
            <Tab label={this.props.returnLocalizedString("m0276")} ></Tab>
        </Tabs>);

        //!DBTRANS! @m0004@ Home !DEVNOTE! Option label
        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0036@ Success! !DEVNOTE! Action status reason
        //!DBTRANS! @m0101@ Cancel !DEVNOTE! Option label
        //!DBTRANS! @m0251@ Would you like to save your changes? !DEVNOTE! Option label
        //!DBTRANS! @m0252@ Save !DEVNOTE!Option label
        //!DBTRANS! @m0253@ Exit without saving !DEVNOTE! Option label
        //!DBTRANS! @m0254@ parts/pkg !DEVNOTE! Attribute label
        //!DBTRANS! @m0255@ By%space% !DEVNOTE! Attribute label
        //!DBTRANS! @m0256@ Min qty%space% !DEVNOTE! Input field label
        //!DBTRANS! @m0257@ Part number !DEVNOTE! Input field label
        //!DBTRANS! @m0258@ Description !DEVNOTE! Input field label
        //!DBTRANS! @m0259@ Vendor !DEVNOTE! Input field label
        //!DBTRANS! @m0260@ Avail !DEVNOTE! Input field label
        //!DBTRANS! @m0261@ Sold !DEVNOTE! Input field label
        //!DBTRANS! @m0262@ Stock min !DEVNOTE! Input field label
        //!DBTRANS! @m0263@ Min expire !DEVNOTE! Input field label
        //!DBTRANS! @m0264@ Stock max !DEVNOTE! Input field label
        //!DBTRANS! @m0265@ Max expire !DEVNOTE! Input field label
        //!DBTRANS! @m0266@ Season !DEVNOTE! Input field label
        //!DBTRANS! @m0267@ Never order !DEVNOTE! Input field label
        //!DBTRANS! @m0268@ Modified !DEVNOTE! Input field label
        //!DBTRANS! @m0269@ All Exceptions !DEVNOTE! Input field label
        //!DBTRANS! @m0270@ You must specify a part number or an exception in search filter. !DEVNOTE! Action status reason
        //!DBTRANS! @m0271@ Unable to retrieve part exceptions. Please try again. !DEVNOTE! Action status reason
        //!DBTRANS! @m0272@ You must select an adjustment reason for part number %var1%! !DEVNOTE! Action status reason
        //!DBTRANS! @m0273@ Warning! !DEVNOTE! Action status reason
        //!DBTRANS! @m0274@ No record is modified. !DEVNOTE! Action status reason
        //!DBTRANS! @m0275@ The %var1% part exception(s) have been successfully updated. !DEVNOTE! Action status reason
        //!DBTRANS! @m0276@ Part Exceptions !DEVNOTE! Action status reason
        //!DBTRANS! @m0277@ Here are the results based on your filters !DEVNOTE! Action status reason
        //!DBTRANS! @m0278@ Edit !DEVNOTE! Option label
        //!DBTRANS! @m0279@ Settings !DEVNOTE! Option label
        //!DBTRANS! @m0280@ Details !DEVNOTE! Option label
        //!DBTRANS! @m0281@ Demand !DEVNOTE! Option label
        return (
            <div>
                <Header title={this.props.returnLocalizedString("m0276")} tabs={tabs} />

                <section className="page-content grid-row pad-it">
                    <PartExceptionsSearchBox
                        fieldRequired={this.fieldRequired}
                        searchParams={this.state.searchParams}
                        handleSearchParamsChange={this.handleSearchParamsChange}
                        handleSearch={this.handleSearch}
                    />
                    {
                        this.state.showNavigateAwayDialog && (
                            <NavigateAwayDialog
                                handleConfirmNavigate={this.handleConfirmNavigate}
                                handleCloseDialog={this.handleCloseDialog}
                                handleSave={this.handleSave}
                                returnLocalizedString = {this.returnLocalizedString}
                            />
                        )
                    }
                    <Prompt
                        when={this.state.unsaved}
                        message={location => {
                            this.showNavigateAwayDialog(`${location.pathname}${location.search}`);
                            return false
                        }}
                    />
                    {this.state.partExceptions ? (
                        <div className="search-results-header">{this.props.returnLocalizedString("m0277")}</div>)
                        : (
                            <span />
                        )}
                    {this.state.partExceptions ? (
                        <GridContainer
                            sortColumn="partNumber"
                            data={this.state.partExceptions}
                            //pageable={true}
                            excelFilename={getExportFileName("Part-Exceptions")}
                            editField="inEdit"
                            onItemChange={this.handleItemChange}
                        >

                            <Column
                                field="partNumber"
                                title={this.props.returnLocalizedString("m0257")}
                                width={this.setWidth(90, 8)}
                                editable={false}
                            />
                            <Column
                                field="partDescription"
                                title={this.props.returnLocalizedString("m0258")}
                                width={this.setWidth(100, 18)}
                                editable={false}
                                cell={localize(DescWithPackageInfoCell)}
                            />
                            <Column
                                field="vendorCode"
                                title={this.props.returnLocalizedString("m0259")}
                                width={this.setWidth(70, 6)}
                                editable={false}
                            />
                            <Column
                                field="qtyAvailable"
                                title={this.props.returnLocalizedString("m0260")}
                                width={this.setWidth(60, 6)}
                                headerClassName="numeric"
                                className="numeric"
                                editable={false}
                            />
                            <Column
                                field="qtySold"
                                title={this.props.returnLocalizedString("m0261")}
                                width={this.setWidth(60, 6)}
                                headerClassName="numeric"
                                className="numeric"
                                editable={false}
                            />
                            <Column
                                field="stockingMIN"
                                title={this.props.returnLocalizedString("m0262")}
                                headerClassName="numeric"
                                className="numeric"
                                width={this.setWidth(60, 6)}
                                editable={false}
                                cell={StockingMinMaxCell}
                            />
                            <Column
                                field="minExpiryDate"
                                title={this.props.returnLocalizedString("m0263")}
                                width={this.setWidth(60, 6)}
                                cell={props => (
                                    <DateCell {...props} />
                                )}
                                editable={false}
                            />
                            <Column
                                field="stockingMAX"
                                title={this.props.returnLocalizedString("m0264")}
                                headerClassName="numeric"
                                className="numeric"
                                width={this.setWidth(60, 6)}
                                editable={false}
                                cell={StockingMinMaxCell}
                            />
                            <Column
                                field="maxExpiryDate"
                                title={this.props.returnLocalizedString("m0265")}
                                width={this.setWidth(60, 6)}
                                cell={props => (
                                    <DateCell {...props} />
                                )}
                                editable={false}
                            />
                            <Column
                                field="season.seasonName"
                                title={this.props.returnLocalizedString("m0266")}
                                width={this.setWidth(75, 6)}
                                cell={props => (
                                    <SeasonCell label = {this.props.returnLocalizedString("m0256")} {...props} />
                                )}
                                editable={false}
                            />
                            <Column
                                field="neverOrder"
                                title={this.props.returnLocalizedString("m0267")}
                                headerClassName="boolean"
                                className="boolean"
                                width={this.setWidth(60, 12)}
                                cell={NeverOrderCell}
                            />
                            <Column
                                field="modifiedOn"
                                title={this.props.returnLocalizedString("m0268")}
                                width={this.setWidth(60, 8)}
                                cell={props => (
                                    <ModifiedCell label = {this.props.returnLocalizedString("m0255")} {...props} />
                                )}
                                editable={false}
                            />
                            <Column
                                filterable={false}
                                resizable={false}
                                sortable={false}
                                reorderable={false}
                                editable={false}
                                width={this.setWidth(20, 3)}
                                cell={(props) => (
                                    <IconButtonCell handleClick={(e) => { this.handleEditClick(e, props) }} icon="Edit" title={this.props.returnLocalizedString("m0279")} {...props} />
                                )}
                            />
                            <Column
                                filterable={false}
                                resizable={false}
                                sortable={false}
                                reorderable={false}
                                editable={false}
                                width={this.setWidth(20, 3)}
                                cell={(props) => (
                                    <IconButtonCell handleClick={(e) => { this.handleDetailsClick(e, props) }} icon="Details" title={this.props.returnLocalizedString("m0281")} {...props} />
                                )}
                            />
                            <Column
                                filterable={false}
                                resizable={false}
                                sortable={false}
                                reorderable={false}
                                editable={false}
                                cell={(props) => (
                                    <BlankCell {...props} />
                                )}
                            />
                        </GridContainer>

                    ) : (
                            <span />
                        )}
                </section>
                {this.state.showDialog && (
                    <Dialog
                        className="edit"
                        style={{ top: top }}
                        width={partExceptionDialogWidth}
                        minWidth={320}
                        closeIcon={false}
                    >
                        <EditPartExceptionPage
                            handleCloseModal={this.handleCloseModal}
                            handleRefreshListing={this.handleSearch}
                            orgID={this.state.orgID}
                            orgVendorID={this.state.selectedException.orgVendorID}
                            partNumber={this.state.selectedException.partNumber}
                            seasons={this.state.seasons}
                            adjustmentReasons={this.state.adjustmentReasons} />
                    </Dialog>)
                }
                {this.state.showDetailsDialog && (
                    <Dialog
                        className="demand"
                        style={{ top: top }}
                        width={partDemandDialogWidth}
                        minWidth={320}
                        closeIcon={false}
                    >
                        <PartDemandPage
                            handleCloseModal={this.handleCloseDetailsModal}
                            orgID={this.state.orgID}
                            orgVendorID={this.state.selectedException.orgVendorID}
                            partNumber={this.state.selectedException.partNumber} />
                    </Dialog>)
                }
            </div>
        );
    }
}
export default compose(isPage, withRouter)(PartExceptionsPage);
PartExceptionsPage.contextType = AppContext;
//export default isPage(PartExceptionsPage);



// WEBPACK FOOTER //
// ./src/containers/PartExceptionsPage.js